import { createContext, useState } from 'react';
import { useModal } from 'src/services/modal';

const ReviewContext = createContext();

export default ReviewContext;

const useReviewInfo = () => {
  const [review, setReview] = useState({
    businessInfo: {},
    priorAssets: { priorQuantity: '', priorValue: '' },
    assetsAdded: { quantityAdded: '', valueAdded: '' },
    assetsRetired: { quantityRetired: '', valueRetired: '' },
    assetsChanged: { qty: '', val: '' },
    updatedInfo: {
      multipleAccts: '',
      associatedAcctInfo: '',
      ownerChg: '',
      reqExempt: '',
      busStatus: '',
    },
    leasedAssets: {},
    businessContacts: [],
    updatedBusinessContacts: [],
  });
  return { review, setReview };
};

const useExemptionNotificationModal = () => {
  const [hasBeenDisplayed, setHasBeenDisplayed] = useState(false);
  const exemptionNotificationModalController = useModal();
  return { exemptionNotificationModalController, hasBeenDisplayed, setHasBeenDisplayed };
};

const useItemizeModal = () => {
  const itemizeModalController = useModal();
  return { itemizeModalController };
};

const useExemptionModal = () => {
  const exemptionModalController = useModal();
  return { exemptionModalController };
};

const useNeedToItemizeModal = () => {
  const needToItemizeModalController = useModal();
  return { needToItemizeModalController };
};

export const ReviewProvider = (props) => {
  const reviewInfo = useReviewInfo();
  const exemptionNotificationModal = useExemptionNotificationModal();
  const exemptionModal = useExemptionModal();
  const itemizeModal = useItemizeModal();
  const needToItemizeModal = useNeedToItemizeModal();

  const contextValue = {
    exemptionModal,
    exemptionNotificationModal,
    reviewInfo,
    itemizeModal,
    needToItemizeModal,
  };

  return <ReviewContext.Provider value={contextValue}>{props.children}</ReviewContext.Provider>;
};
